export enum WithdrawDashboardTypes {
  FETCH_WITHDRAW_SUCCESS = 'FETCH_WITHDRAW_SUCCESS',
  FETCH_WITHDRAW_FAILURE = 'FETCH_WITHDRAW_FAILURE',
}
